
  import {Component, Vue} from 'vue-property-decorator'
  import {DeviceType, AppModule} from '@/store/modules/app'
  import {AppMain, Navbar, Sidebar} from './components'

  @Component({
    name: 'LayoutWithoutResize',
    components: {
      AppMain,
      // Navbar,
      //Sidebar
    }
  })
  export default class extends Vue {
    get classObj() {
      return {
        hideSidebar: true
        // hideSidebar: !this.sidebar.opened,
        // openSidebar: this.sidebar.opened,
        // withoutAnimation: this.sidebar.withoutAnimation,
        // mobile: this.device === DeviceType.Mobile
      }
    }

    private handleClickOutside() {
      AppModule.CloseSideBar(false)

    }
  }
